import { render, staticRenderFns } from "./CommonPostDetail.vue?vue&type=template&id=3a5ec49c"
import script from "./CommonPostDetail.vue?vue&type=script&lang=js"
export * from "./CommonPostDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports